// extracted by mini-css-extract-plugin
export default {"sizes":"'../../../style/display.css'","tablet":"812px","diagram-container":"Diagram_diagram-container__3jSjP","diagram":"Diagram_diagram__iV8LD","startBtn":"Diagram_startBtn__UB+ff"};